import Link from "next/link";
import { useRouter } from "next/router";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Button, Separator, Text } from "@nju/ui";

interface IRegistrationPageProps {
  offerId: string | undefined;
}

export function NextStepsPage({ offerId }: IRegistrationPageProps) {
  const router = useRouter();

  const next = () => {
    router.push(
      portalRoutes.zalozKonto.get({
        oferta: offerId,
        mode: "ftth",
      }),
    );
  };

  return (
    <div className="mx-auto max-w-[715px]" data-cy="main-content">
      <Text
        size={{
          "@onlyMobile": "l",
          "@fromTablet": "xl",
        }}
        weight="bold"
      >
        Wybrana oferta:
      </Text>
      <Text
        className="ml-2"
        size={{
          "@onlyMobile": "l",
          "@fromTablet": "xl",
        }}
        tone="accent"
        weight="bold"
      >
        nju światłowód
      </Text>
      <Separator size="xl" />
      <Text
        size={{
          "@onlyMobile": "xl",
          "@fromTablet": "keyM",
        }}
        testId="header"
        weight="bold"
      >
        kolejne kroki do złożenia zamówienia
      </Text>
      <div className="mt-8">
        <div className="flex flex-col gap-5">
          <div className="flex gap-4">
            <div className="bg-daintree rounded-full min-w-[42px] h-[42px] flex justify-center items-center relative">
              <div className="bg-cerulean rounded-full w-3 h-3 flex items-center justify-center absolute -top-[2px] -left-[2px]">
                <Text size="xs" tone="secondary">
                  1
                </Text>
              </div>
              <Icon height={21} name="user-check" tone="secondary" width={21} />
            </div>
            <div>
              <BlockText size="m" weight="bold">
                załóż konto
              </BlockText>
              <BlockText className="mt-1" size="s">
                W następnym kroku założysz konto dla usług z subskrypcją (nju
                światłowód i nju subskrypcja).
              </BlockText>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="bg-daintree rounded-full min-w-[42px] h-[42px] flex justify-center items-center relative">
              <div className="bg-cerulean rounded-full w-3 h-3 flex items-center justify-center absolute -top-[2px] -left-[2px]">
                <Text size="xs" tone="secondary">
                  2
                </Text>
              </div>
              <Icon
                height={21}
                name="file-spreadsheet"
                tone="secondary"
                width={21}
              />
            </div>
            <div>
              <BlockText size="m" weight="bold">
                dane i termin instalacji
              </BlockText>
              <BlockText className="mt-1" size="s">
                Potwierdzisz swoją tożsamość i wybierzesz termin instalacji
                usługi.
              </BlockText>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="bg-daintree rounded-full min-w-[42px] h-[42px] flex justify-center items-center relative">
              <div className="bg-cerulean rounded-full w-3 h-3 flex items-center justify-center absolute -top-[2px] -left-[2px]">
                <Text size="xs" tone="secondary">
                  3
                </Text>
              </div>
              <Icon height={18} name="wallet" tone="secondary" width={18} />
            </div>
            <div>
              <BlockText size="m" weight="bold">
                zgody i płatność
              </BlockText>
              <BlockText className="mt-1" size="s">
                Zaznaczysz wymagane zgody i wybierzesz sposób płatności za
                usługę.
              </BlockText>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="bg-daintree rounded-full min-w-[42px] h-[42px] flex justify-center items-center relative">
              <div className="bg-cerulean rounded-full w-3 h-3 flex items-center justify-center absolute -top-[2px] -left-[2px]">
                <Text size="xs" tone="secondary">
                  4
                </Text>
              </div>
              <Icon
                height={18}
                name="shopping-basket"
                tone="secondary"
                width={18}
              />
            </div>
            <div>
              <BlockText size="m" weight="bold">
                podsumowanie zamówienia
              </BlockText>
              <BlockText className="mt-1" size="s">
                Na koniec otrzymasz podsumowanie i potwierdzenie złożenia
                zamówienia.
              </BlockText>
            </div>
          </div>
        </div>
      </div>
      <Separator size="xl" />
      <div className="flex justify-between only-mobile:flex-col-reverse only-mobile:gap-3">
        <Link href={portalRoutes.wybierzOferte.get()} passHref={true}>
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            powrót
          </A>
        </Link>
        <Button
          onPress={next}
          size={{
            "@onlyMobile": "s",
          }}
        >
          przejdź dalej
        </Button>
      </div>
    </div>
  );
}
